import React from 'react';
import Slider from 'react-slick';

const BrandOne = ({...restProps})=> {

  const settings = {
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {          
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {          
          slidesToShow: 2,
        }
      }
    ]
  }; 
  
  return (
    <div {...restProps}>    
      <div className="container">
        <div className="sec-line-wrap">
          <div className="sec-line"></div>
          <h2 className="sec-title2">Our Trusted Clients</h2>
          <div className="sec-line"></div>
        </div>
        <Slider className="row text-center" {...settings}>
          <div><img src="images/brand/eksu.jpg" alt="brands"/></div>
          <div><img src="images/brand/bouesti.jpeg" alt="brands"/></div>
          <div><img src="images/brand/coe.jpg" alt="brands"/></div>
          <div><img src="images/brand/oaustech.jpeg" alt="brands"/></div>
          <div><img src="images/brand/rugipologo.jpg" alt="brands"/></div>
        </Slider>
      </div>
    </div>
  );
}

export default BrandOne;